module.exports = __webpack_public_path__ + "img/1-1.67b60dcc.jpg";